import React, { useEffect, useState } from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import Summary from './Summary';
import ComplementoRow from './ComplementoRow';

import {
  useProdutoPizza,
  ItemComplemento,
  Complemento,
} from '../../../../../../../hooks/produtoPizza';

import { AccordionWrapper } from '../../../drawer_styles';

interface ComplementoData extends Complemento {
  itens_complemento: ItemComplemento[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    accordionItem: {
      borderTopLeftRadius: '0 !important',
      borderTopRightRadius: '0 !important',
      margin: '0 !important',
    },
    accordionDetails: {
      display: 'block',
      paddingTop: '0',
    },
  }),
);

const AcordeaoComplementos: React.FC = () => {
  const classes = useStyles();
  const [complementos, setComplementos] = useState<ComplementoData[]>([]);

  const { produtoPizzaData } = useProdutoPizza();

  useEffect(() => {
    const parsedComplementos = produtoPizzaData.complementos.map(
      (complemento): ComplementoData => ({
        ...complemento,
        itens_complemento: produtoPizzaData.itens_complemento.filter(
          (item) => item.index_complemento === complemento.index,
        ),
      }),
    );

    setComplementos(parsedComplementos);
  }, [produtoPizzaData]);

  return (
    <>
      {complementos.map((complemento) => (
        <AccordionWrapper key={complemento.index}>
          <div className={classes.root}>
            <Accordion className={classes.accordionItem}>
              <Summary
                index={complemento.index}
                title={complemento.descricao}
                isObrigatorio={complemento.complemento_obrigatorio}
              />

              <AccordionDetails className={classes.accordionDetails}>
                {complemento.itens_complemento
                  .sort((a, b) => a.ordem - b.ordem)
                  .map((item_complemento) => (
                    <>
                      {item_complemento.index_complemento ===
                        complemento.index && (
                        <ComplementoRow
                          descricao={item_complemento.descricao}
                          preco={item_complemento.preco.toString()}
                          key={item_complemento.id}
                        />
                      )}
                    </>
                  ))}
              </AccordionDetails>
            </Accordion>
          </div>
        </AccordionWrapper>
      ))}
    </>
  );
};

export default AcordeaoComplementos;
